import { Component, OnInit, Input } from '@angular/core';
import { FormatoAsistencialEntity, FiltrosFormatoAsistencialEntity, NodoEntity, ServicioFormatoAsistencialService } from 'src/app/services/servicio-formato-asistencial.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-audiometria-vocal',
  templateUrl: './audiometria-vocal.component.html',
  styleUrls: ['./audiometria-vocal.component.css']
})
export class AudiometriaVocalComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() nodo: NodoEntity;

  titulo: string;
  img: string;
  infoAdicional: any;

  constructor( private servicioFormato: ServicioFormatoAsistencialService) { }

  ngOnInit() {
    if (this.nodo && this.filtros) {
      this.onProcess();
    } else {
      this.titulo = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.getInfoAdicional();
    this.getImagen();
  }

  getInfoAdicional() {
    try{
      if (this.nodo && this.nodo.datos && this.nodo.datos.length > 0) {
        const dato = this.nodo.datos[0];
        const info = JSON.parse(dato.valor);
        this.infoAdicional = info.data_info;
      }else{
        this.infoAdicional = null;
      }
    }catch (e) {
      this.infoAdicional = null;
    }
  }

  async getImagen() {
    const request = await this.servicioFormato.getImagenNodo(this.filtros.codigoBaseDatos, this.filtros.entidadEmpresarial.unco, this.filtros.tta, this.nodo.id);
    request.subscribe((data: any) => {
      this.img = data.source;
    }, (err: HttpErrorResponse) => {
      this.img = null;
      console.error('Error Audiometria Tonal', err);
    })
  }

}
